import { RATE_LOCK_TERMS_CRITERIA_ACTION_TYPE } from '../actions';

const initialState = {};

const rateLockTermsSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case RATE_LOCK_TERMS_CRITERIA_ACTION_TYPE.GET_CRITERIA_SCHEMA:
      return payload || initialState;

    default:
      return state;
  }
};

export default rateLockTermsSchemaReducer;
